import React, { useRef, useState, forwardRef, useEffect } from 'react'
import ReactDatePicker from 'react-datepicker'

import { getYear, format } from 'date-fns'
import { ko } from 'date-fns/esm/locale'
import { IconButton } from 'components'
import { backPressState } from 'store/atom/app-state-atom'
import { useRecoilValue } from 'recoil'

// css
import 'react-datepicker/dist/react-datepicker.css'
import 'assets/style/elements/datepicker.scss'
import 'assets/css/calendar.css'

function MonthPicker({
  value = '',
  className = '',
  dateFormat = 'yyyy.MM',
  placeholder = 'yyyy.MM',
  disabled = false,
  onChange = () => {},
}) {
  let todate = new Date()

  const [calValue, setCalValue] = useState(format(todate, dateFormat))
  const [date, setDate] = useState(todate)
  const calRef = useRef(null)

  let years = []
  for (let i = 1900; i <= 2400; i++) {
    years.push(i)
  }

  const backPress = useRecoilValue(backPressState)

  useEffect(() => {
    if (calRef.current.isCalendarOpen()) {
      closeCalendar()
    }
  }, [backPress])

  // useEffect(() => {
  //   let dateStr = value?.replace(/-/g, '').replace(/\./g, '')
  //   let typeDate = todate
  //   if (dateStr !== '') {
  //     typeDate = parse(dateStr, 'yyyyMM', new Date())
  //     dateStr = format(parse(dateStr, 'yyyyMM', new Date()), 'yyyy-MM')
  //   }
  //   setDate(typeDate)
  //   setCalValue(dateStr)
  // }, [value])

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <div className="input-text-wrap  in-icon icon-date">
      <input
        value={value}
        onClick={onClick}
        onChange={onChange}
        className={'input-text'}
        placeholder={placeholder}
        readOnly={true}
        ref={ref}
      />
      <button className={'btn-icon date'} onClick={onClick} />
    </div>
  ))

  const selectedHandler = (date) => {
    setCalValue(format(date, dateFormat))
    setDate(date)
    onChange(date)
    calRef.current.setOpen(false)
  }

  const closeCalendar = () => {
    calRef.current.setOpen(false)
  }

  const MonthHeader = ({
    date,
    changeYear,
    decreaseYear,
    increaseYear,
    prevYearButtonDisabled,
    nextYearButtonDisabled,
  }) => (
    <>
      <header className={`site-header site-header-popup`} style={{ padding: '0' }}>
        <div className="row relative" style={{ height: '25px' }}>
          <div className="right" style={{ backgroundColor: '#ffffff', top: '0px' }}>
            <IconButton size="20" bg="white" type="close" onClick={() => closeCalendar()} />
          </div>
        </div>
      </header>
      <div className="rdrMonthAndYearWrapper">
        <button
          type="button"
          class="rdrNextPrevButton rdrPprevButton"
          onClick={decreaseYear}
          disabled={prevYearButtonDisabled}
        >
          <i></i>
        </button>
        <span class="rdrMonthAndYearPickers">
          <span class="rdrMonthPicker">
            <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(Number(value))}>
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}년
                </option>
              ))}
            </select>
          </span>
        </span>
        <button
          type="button"
          class="rdrNextPrevButton rdrNextButton"
          onClick={increaseYear}
          disabled={nextYearButtonDisabled}
        >
          <i></i>
        </button>
      </div>
    </>
  )

  return (
    <>
      <ReactDatePicker
        ref={calRef}
        locale={ko}
        value={calValue}
        dateFormat={dateFormat}
        withPortal={true}
        date={new Date()}
        selected={date}
        onSelect={selectedHandler}
        customInput={<CustomInput />}
        //onChange={selectedHandler}
        shouldCloseOnSelect={false}
        showMonthYearPicker={true}
        showYearPicker={false}
        renderCustomHeader={MonthHeader}
        showFourColumnMonthYearPicker
        //readOnly={readOnly}
      />
    </>
  )
}

export default MonthPicker
